var React = require('react');

function SpeechBubble (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"style":{"fill":"#D5DC74"},"d":"M404.1,428c0,0-23.6-58.3-136.5-49.2c-225.4,18-294.2-89.6-257-213.3C54.9,18.1,357.8-36.8,522.3,73.3\r\n\t\tc87.6,58.6,100,183.9,27.3,257.9c-23.5,23.9-55.2,41.5-74.2,53.6C451.2,400.3,404.1,428,404.1,428z","key":0}),React.createElement("path",{"style":{"fill":"#FFFFFF"},"d":"M404.1,413.8c0,0-23.6-58.3-136.5-49.2C42.1,382.7-26.7,275,10.6,151.3C54.9,4,357.8-51,522.3,59.2\r\n\t\tc87.6,58.6,100,183.9,27.3,257.9c-23.5,23.9-55.2,41.5-74.2,53.6C451.2,386.1,404.1,413.8,404.1,413.8z","key":1})]));
}

SpeechBubble.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 598 429","style":{"enableBackground":"new 0 0 598 429"},"xmlSpace":"preserve"};

module.exports = SpeechBubble;

SpeechBubble.default = SpeechBubble;
